import { nowUTC } from "@homebound/activesupport";
import { PageBanner } from "@homebound/beam";
import { useState } from "react";
import { pluralize } from "src/utils";
import { useReloadCostsBannerQuery } from "./ReloadCostsBanner.generated";

type ReloadCostsBannerProps = { productOfferingIds: string[]; onReload: () => Promise<unknown> | void };

/** Polls for configurations modified after the costs were loaded, and asks to reload when any exist. */
export function ReloadCostsBanner(props: ReloadCostsBannerProps) {
  const { productOfferingIds, onReload } = props;
  const [loadedAt, setLoadedAt] = useState(nowUTC);
  const query = useReloadCostsBannerQuery({
    variables: { filter: { productOfferings: productOfferingIds, afterUpdatedAt: loadedAt } },
    // Refresh every 15 seconds
    pollInterval: 15_000,
    fetchPolicy: "no-cache",
    skip: productOfferingIds.isEmpty,
  });
  const updatedConfigurations = query.data?.costConfigurationSummaries.entities.length ?? 0;

  if (updatedConfigurations === 0) {
    return null;
  }

  return (
    <PageBanner
      type="info"
      title="Updated Costs Ready"
      description={`Updated calculations are ready for ${updatedConfigurations} ${pluralize(updatedConfigurations, "configuration")}.`}
      primaryAction={{
        label: "Refresh Costs",
        onClick: async () => {
          setLoadedAt(nowUTC());
          await onReload();
        },
      }}
    />
  );
}
